import AgentApplications from "../../../jsx/components/Dashboard/AgentApplications/agentApplications";

const ApplicatiionsWrapper = () => {
  return <AgentApplications />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.agent];

export default constore(ApplicatiionsWrapper);
